export const BRAND_DEFAULTS = {
  primary: "#1C1917",
  accent: "#C25E38",
  star: "#EAB308",
};

export const getBrand = (r) => ({
  name: r?.name || "",
  description: r?.description || "",
  logoUrl: r?.logo_url || null,
  primary: r?.color_primary || BRAND_DEFAULTS.primary,
  accent: r?.color_secondary || BRAND_DEFAULTS.accent,
  star: r?.color_secondary || BRAND_DEFAULTS.star,
});

export const brandVars = (brand) => ({
  "--brand-primary": brand.primary,
  "--brand-accent": brand.accent,
});
